import axiosConfig from "./axiosConfig";

// 202 kickoff response: the lookups run as a long-running operation, so the
// caller polls /operations/<operationKey> and re-reads its list when it lands.
export interface LeadCommercialResolveResponse {
  status: string;
  operationKey: string;
  siteId: string;
  rowCount: number;
  // True when this key is an ALREADY-RUNNING identical resolve the BE coalesced
  // onto - the lookups draw on a per-token Companies House budget and billed
  // Places calls, so a second tab must join the live run rather than repeat it.
  deduped?: boolean;
}

// Fetch the Companies House size band and Google Maps footprint for rows whose
// tenant has not been looked up yet.
//
// The list endpoints derive that view from cache on read and never fetch, so an
// un-looked-up tenant renders as "Calculating" until something does the
// looking. This is that something: call it once for the pending rows on a page,
// poll the operation, then refetch the list.
//
// Asynchronous because the work is upstream-bound - Companies House is limited
// to 600 requests / 5 minutes on a key shared with the postcode search - so a
// page of distinct tenants would run past the 29s API Gateway ceiling.
const postLeadCommercialResolve = async (
  authToken: string,
  body: { leadIds?: string[]; sourceRefs?: string[] }
): Promise<LeadCommercialResolveResponse> => {
  const { data } = await axiosConfig.post("/leads/commercial-resolve", body, {
    headers: { Authorization: `Bearer ${authToken}` },
  });
  return data;
};

export default postLeadCommercialResolve;
